import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SearchResultComponent = (props) => {
    const [t] = useTranslation("common");
    
    return (
        <Box
            style={{
                display: 'flex',
                backgroundColor:'#E6E6E6',//:'#0067B80A #E6E6E6',
                padding:'10px',
                borderRadius:'10px',
                marginLeft:'10px',
                marginRight:'10px',

            }}
        >
            <Typography sx={{
                fontFamily: 'Cairo',
            }}>{t('GLOBAL.SEARCH_RESULT_OF_SEARCH')}  {props?.resultLength}
            </Typography>
        </Box>
    );
};

export default SearchResultComponent;
